import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/** Space persons API, for fetching space persons */
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => {
      if (!context) {
        return rxjs.of([])
      }
      return gql.queries.persons.executor(context)
    },
  )
}
